// extracted by mini-css-extract-plugin
module.exports = {"mobile-indent":"ProductListView_mobile-indent__tNdra"};